import React, { useEffect, useRef, useState } from 'react';
import { etiquette } from '../data/mock';
import { Crown } from 'lucide-react';

const Etiquette = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="etiquette"
      ref={sectionRef}
      className="bg-[#0a0908] py-16 md:py-24 lg:py-32 px-4 md:px-6 overflow-hidden"
    >
      <div className="container mx-auto max-w-4xl">
        {/* Section Header */}
        <div
          className={`text-center mb-16 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {/* Divider */}
          <div className="flex items-center justify-center mb-8">
            <div className="flex-1 h-[1px] bg-gradient-to-r from-transparent to-[#8B7355]/30" />
            <div className="mx-4 w-2 h-2 rotate-45 border border-[#8B0000]" />
            <div className="flex-1 h-[1px] bg-gradient-to-l from-transparent to-[#8B7355]/30" />
          </div>

          <h2 className="text-[#A69080] text-2xl md:text-3xl tracking-[0.3em] uppercase mb-4">
            {etiquette.title}
          </h2>

          {/* Divider */}
          <div className="flex items-center justify-center mt-8">
            <div className="flex-1 h-[1px] bg-gradient-to-r from-transparent to-[#8B7355]/30" />
            <div className="mx-4 w-2 h-2 rotate-45 border border-[#D4A853]" />
            <div className="flex-1 h-[1px] bg-gradient-to-l from-transparent to-[#8B7355]/30" />
          </div>

          <p className="text-[#8B7355] mt-8 text-base md:text-lg">
            Rules and expectations for those who wish to serve.
          </p>
        </div>

        {/* Rules List */}
        <div className="space-y-8">
          {etiquette.rules.map((rule, index) => (
            <div
              key={index}
              className={`transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <div className="group p-6 md:p-8 border-l-2 border-[#8B7355]/30 hover:border-[#D4A853] transition-all duration-500 hover:bg-[#D4A853]/5">
                <div className="flex items-start gap-4">
                  <Crown className="w-5 h-5 text-[#D4A853] mt-1 flex-shrink-0" />
                  <div>
                    <h3 className="text-[#D4A853] text-lg tracking-[0.15em] uppercase mb-3">
                      {rule.title}
                    </h3>
                    <p className="text-[#A69080] text-base leading-relaxed">
                      {rule.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Etiquette;
